{"debug":true,"testing":false,"baseUrl":"https://test.apply.se/","apiUrl":"https://test.apply.se/api/","controlV2Url":"https://test-control.apply.se"}